import React from 'react'
import FooterSection from '../index/FooterSection'
import WeAreBuildingBanking from '../about/WeAreBuildingBanking'
import WeAreMoreThanInternational from './WeAreMoreThanInternational'
import "../assets/images/fastest-logo.png";
import FormC from './FormC'

export default function Contact() {
    return (
        <div>
            <WeAreBuildingBanking />
            <div class="bg-[url('/image/fastest-logo.png')] -bg-[10%] bg-center bg-no-repeat">
                <div className='bg-white opacity-70'>
                <WeAreMoreThanInternational />
                <FormC />
                </div>
            </div>



            <FooterSection />
        </div>
    )
}
